import {HoverPattern, makeHoverPattern} from "./utils";
import {
	FunctionArgumentTree,
	FunctionDeclarationTree,
	LocalVariableDeclarationListTree,
	ModifierTree,
} from "../model";
import {Keyword} from "../lexer";

const static_ = makeHoverPattern(
	[FunctionDeclarationTree, ModifierTree, Keyword.static] as const,
	(_chain, scope, a, b, c) => {
		return `The <code>static</code> keyword means that this function, <code>${a.name.value}</code>, is a class method. It can be called without an instance of the class.`;
	}
);

const finalFunctionArgument = makeHoverPattern(
	[FunctionArgumentTree, Keyword.final] as const,
	(_chain, scope, a, b) => {
		const argName = a.name?.identifier
			? `, <code>${a.name?.identifier}</code>,`
			: "";

		return `The <code>final</code> keyword means that this function argument${argName} cannot be reassigned.`;
	}
);

const finalLocalVariable = makeHoverPattern(
	[LocalVariableDeclarationListTree, ModifierTree, Keyword.final] as const,
	(_chain, scope, a, b, c) => {
		return `The <code>final</code> keyword means that these local variables cannot be reassigned.`;
	}
);

export const MODIFIERS_HOVERS: HoverPattern<any, any>[] = [
	static_,
	finalFunctionArgument,
	finalLocalVariable,
];
